import ClientModule from "@gqlapp/module-client-react";
import Home from "@modules/home/containers/home";
export default new ClientModule(Home);
